import 'css-chunk:src/app/components/SearchInput/SearchInput.scss';export default {
  "searchWrapper": "_searchWrapper_87vy9_1",
  "searchIcon": "_searchIcon_87vy9_8",
  "searchInput": "_searchInput_87vy9_19",
  "clearButton": "_clearButton_87vy9_35"
};